import { makeStyles, tokens } from "@fluentui/react-components";
/** Styles for the CreatePortfolioDialog  */ export const useCreatePortfolioDialogStyles = makeStyles({
    root: {
        width: "100%",
        maxWidth: "1109px",
        height: "646px",
        display: "flex",
        flexDirection: "column",
        overflow: "auto"
    },
    body: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        minHeight: 0
    },
    headerRow: {
        boxSizing: "border-box",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    dismissButton: {
        borderRadius: tokens.borderRadiusMedium
    },
    stepArea: {
        position: "relative",
        width: "100%",
        flexGrow: 1,
        minHeight: 0,
        height: "100%",
        overflow: "hidden"
    },
    detailsContainer: {
        display: "flex",
        flexDirection: "row",
        width: "100%",
        height: "100%",
        gap: tokens.spacingHorizontalL,
        alignItems: "stretch",
        maxWidth: "100%",
        boxSizing: "border-box",
        overflow: "hidden"
    },
    stepPanel: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        opacity: 0,
        transform: `translateX(${tokens.spacingHorizontalXL})`,
        transition: "opacity 120ms ease, transform 120ms ease",
        willChange: "opacity, transform",
        zIndex: 0,
        pointerEvents: "none"
    },
    stepPanelActive: {
        opacity: 1,
        transform: "translateX(0)",
        pointerEvents: "auto",
        zIndex: 2
    },
    stepPanelExit: {
        opacity: 0,
        transform: `translateX(calc(${tokens.spacingHorizontalXL} * -1))`,
        pointerEvents: "none",
        zIndex: 1
    }
});
